<template>
  <AuthShell title="Reimposta password">
    <div v-if="done" class="text-center space-y-4">
      <div class="rounded-lg bg-gray-50 border border-gray-200 px-4 py-3 text-sm text-gray-600">
        Password reimpostata con successo.
      </div>
      <router-link
        to="/login"
        class="inline-block text-sm font-semibold text-onibble hover:text-ynibble transition-colors"
      >
        Vai al login →
      </router-link>
    </div>

    <form v-else @submit.prevent="submit" novalidate class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="email">Email</label>
        <input
          id="email"
          v-model="email"
          type="email"
          autocomplete="email"
          required
          :disabled="loading"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="password">Nuova password</label>
        <input
          id="password"
          v-model="password"
          type="password"
          autocomplete="new-password"
          required
          :disabled="loading"
          placeholder="••••••••"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="password_confirmation">Conferma password</label>
        <input
          id="password_confirmation"
          v-model="passwordConfirmation"
          type="password"
          autocomplete="new-password"
          required
          :disabled="loading"
          placeholder="••••••••"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>

      <p v-if="errorMsg" class="text-sm text-red-500">{{ errorMsg }}</p>

      <button
        type="submit"
        :disabled="loading"
        class="w-full py-2.5 px-4 text-sm font-semibold text-gray-900 bg-ynibble rounded-lg shadow-sm hover:bg-onibble focus:outline-none focus:ring-2 focus:ring-onibble disabled:opacity-60 transition-colors"
      >
        <span v-if="loading">Salvataggio…</span>
        <span v-else>Reimposta password</span>
      </button>
    </form>
  </AuthShell>
</template>

<script>
import { resetPassword } from '@/plugins/sessionAuth.js';
import AuthShell from './AuthShell.vue';

export default {
  name: 'ResetPasswordView',
  components: { AuthShell },
  data() {
    return {
      email: this.$route.query.email || '',
      password: '',
      passwordConfirmation: '',
      loading: false,
      errorMsg: '',
      done: false,
    };
  },
  computed: {
    token() {
      return this.$route.query.token || '';
    },
  },
  methods: {
    async submit() {
      this.errorMsg = '';
      if (this.password !== this.passwordConfirmation) {
        this.errorMsg = 'Le password non coincidono.';
        return;
      }
      this.loading = true;
      try {
        await resetPassword(this.token, this.email, this.password, this.passwordConfirmation);
        this.done = true;
      } catch (e) {
        this.errorMsg = e.message || 'Reset fallito. Riprova.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
